<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g :filter="`url(#${unicId})`">
      <path
        d="M17.2198 1.28629C18.0392 0.671383 18.449 0.36393 18.8831 0.201981C19.605 -0.067327 20.3989 -0.067327 21.1208 0.201981C21.5549 0.36393 21.9647 0.671383 22.7841 1.28629C23.2611 1.64421 23.4996 1.82317 23.7565 1.95218C24.1829 2.16622 24.6511 2.28235 25.1275 2.29218C25.4146 2.2981 25.7085 2.25115 26.2961 2.15725C27.3057 1.99594 27.8105 1.91528 28.2697 1.97487C29.0333 2.07395 29.7363 2.44519 30.2511 3.0212C30.5607 3.36758 30.7815 3.83139 31.223 4.75902C31.4801 5.29897 31.6086 5.56895 31.7765 5.80334C32.0552 6.19221 32.4162 6.51399 32.8334 6.74543C33.0849 6.88493 33.3668 6.98075 33.9305 7.17239C34.899 7.50162 35.3832 7.66623 35.7623 7.9337C36.3926 8.37849 36.8436 9.03591 37.0334 9.78666C37.1476 10.2381 37.1289 10.7521 37.0914 11.7799C37.0696 12.3782 37.0587 12.6773 37.0991 12.9634C37.1662 13.438 37.3373 13.8917 37.5998 14.2918C37.7581 14.5329 37.9634 14.7495 38.374 15.1828C39.0795 15.9271 39.4322 16.2993 39.6443 16.7134C39.9971 17.402 40.0928 18.195 39.9141 18.9485C39.8066 19.4016 39.5527 19.8479 39.0447 20.7405C38.7491 21.2601 38.6013 21.5198 38.505 21.7921C38.3452 22.2437 38.287 22.7254 38.3348 23.2024C38.3635 23.4899 38.4453 23.7777 38.6087 24.3534C38.8896 25.3423 39.03 25.8368 39.0266 26.3026C39.0209 27.0773 38.7393 27.8242 38.2331 28.4078C37.9286 28.7588 37.4976 29.0352 36.6356 29.5881C36.1339 29.9099 35.883 30.0708 35.672 30.2668C35.3219 30.592 35.0479 30.9913 34.8699 31.436C34.7625 31.704 34.702 31.9971 34.5809 32.5832C34.3728 33.5902 34.2687 34.0937 34.0505 34.5046C33.6876 35.1878 33.0934 35.7176 32.3755 35.9976C31.9439 36.1661 31.4345 36.2093 30.4159 36.2958C29.823 36.3461 29.5265 36.3713 29.2492 36.4461C28.789 36.5704 28.362 36.7959 27.9989 37.1064C27.7801 37.2935 27.5911 37.5247 27.2131 37.9871C26.5637 38.7814 26.2391 39.1786 25.8561 39.4404C25.2192 39.8757 24.4483 40.0668 23.6834 39.9792C23.2233 39.9265 22.7524 39.7266 21.8105 39.3269C21.2623 39.0942 20.9881 38.9779 20.7079 38.9145C20.2431 38.8093 19.7608 38.8093 19.296 38.9145C19.0158 38.9779 18.7416 39.0942 18.1934 39.3269C17.2515 39.7266 16.7806 39.9265 16.3205 39.9792C15.5556 40.0668 14.7847 39.8757 14.1478 39.4404C13.7648 39.1786 13.4402 38.7814 12.7908 37.9871C12.4128 37.5247 12.2238 37.2935 12.005 37.1064C11.6419 36.7959 11.2149 36.5704 10.7547 36.4461C10.4774 36.3713 10.1809 36.3461 9.58798 36.2958C8.56936 36.2093 8.06005 36.1661 7.62838 35.9976C6.91053 35.7176 6.31626 35.1878 5.9534 34.5046C5.7352 34.0937 5.63115 33.5902 5.42305 32.5832C5.30193 31.9971 5.24136 31.704 5.13404 31.436C4.95599 30.9913 4.68202 30.592 4.33193 30.2668C4.12092 30.0708 3.87005 29.9099 3.36829 29.5881C2.50629 29.0352 2.07528 28.7588 1.77084 28.4078C1.26459 27.8242 0.983053 27.0773 0.97733 26.3026C0.973889 25.8368 1.11432 25.3423 1.39517 24.3534C1.55865 23.7777 1.64038 23.4899 1.66915 23.2024C1.71687 22.7254 1.65874 22.2437 1.49895 21.7921C1.40264 21.5198 1.25482 21.2601 0.959171 20.7405C0.451256 19.8479 0.197298 19.4016 0.0898406 18.9485C-0.0888527 18.195 0.00684552 17.402 0.35957 16.7134C0.571681 16.2993 0.924411 15.9271 1.62987 15.1828C2.0405 14.7495 2.24582 14.5329 2.40408 14.2918C2.66665 13.8917 2.83767 13.438 2.90478 12.9634C2.94524 12.6773 2.93433 12.3782 2.91252 11.7799C2.87505 10.7521 2.85632 10.2381 2.97046 9.78666C3.16027 9.03591 3.61128 8.37849 4.24164 7.9337C4.62071 7.66623 5.10494 7.50162 6.0734 7.17239C6.63711 6.98075 6.91897 6.88493 7.17047 6.74543C7.58774 6.51399 7.94872 6.19221 8.22737 5.80334C8.39532 5.56895 8.52383 5.29897 8.78086 4.75902C9.22242 3.83139 9.4432 3.36758 9.75279 3.0212C10.2676 2.44519 10.9706 2.07395 11.7342 1.97487C12.1934 1.91528 12.6982 1.99594 13.7078 2.15725C14.2954 2.25115 14.5893 2.2981 14.8764 2.29218C15.3528 2.28235 15.821 2.16622 16.2474 1.95218C16.5043 1.82317 16.7428 1.64421 17.2198 1.28629Z"
        :fill="`url(#${unicIdPaint})`"
        style=""
      ></path>
    </g>
    <path
      d="M18.3452 17.5683L19.2218 18.4515L13.5108 24.3085L12.6343 23.4253L18.3452 17.5683ZM12.6343 18.4515L13.5108 17.5683L19.2218 23.4253L18.3452 24.3085L12.6343 18.4515Z"
      fill="white"
      style="fill: white; fill-opacity: 1"
    ></path>
    <path
      d="M21.0814 24.8V23.7839L24.2689 20.4503C24.6939 20.0076 25.0237 19.6446 25.2584 19.3613C25.493 19.0735 25.6568 18.8167 25.7498 18.591C25.8472 18.3652 25.8959 18.1217 25.8959 17.8605V17.8472C25.8959 17.5329 25.8273 17.254 25.69 17.0105C25.5572 16.7626 25.3646 16.57 25.1123 16.4328C24.8599 16.2911 24.5589 16.2203 24.2092 16.2203C23.855 16.2203 23.5429 16.2933 23.2728 16.4394C23.0028 16.5855 22.7925 16.7891 22.642 17.0503C22.4914 17.3115 22.4162 17.617 22.4162 17.9667V17.9933L21.0084 17.9867L21.0017 17.9734C21.0062 17.389 21.1478 16.8733 21.4267 16.4261C21.7056 15.9746 22.093 15.6226 22.5888 15.3703C23.0847 15.1135 23.6536 14.9851 24.2955 14.9851C24.8887 14.9851 25.4177 15.1024 25.8826 15.3371C26.3519 15.5673 26.7215 15.8882 26.9916 16.3C27.2616 16.7072 27.3967 17.1743 27.3967 17.7011V17.721C27.3967 18.0841 27.3302 18.436 27.1974 18.7769C27.0646 19.1178 26.8344 19.4919 26.5068 19.8992C26.1836 20.3065 25.7321 20.7979 25.1521 21.3734L22.7349 23.7839L23.1201 23.1132V23.7839L22.7416 23.525H27.5494V24.8H21.0814Z"
      fill="white"
      style="fill: white; fill-opacity: 1"
    ></path>
    <defs>
      <filter
        :id="unicId"
        x="-23.998"
        y="-24"
        width="88"
        height="88"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
        <feGaussianBlur
          in="BackgroundImageFix"
          stdDeviation="12"
        ></feGaussianBlur>
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1252_10849"
        ></feComposite>
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1252_10849"
          result="shape"
        ></feBlend>
      </filter>
      <radialGradient
        :id="unicIdPaint"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0008 20.2469) rotate(90) scale(21.0485 20.9198)"
      >
        <stop
          stop-color="#49A65B"
          style="
            stop-color: #49a65b;
            stop-color: color(display-p3 0.2848 0.6502 0.3585);
            stop-opacity: 1;
          "
        ></stop>
        <stop
          offset="1"
          stop-color="#53B767"
          stop-opacity="0.71"
          style="
            stop-color: #53b767;
            stop-color: color(display-p3 0.3242 0.7163 0.4033);
            stop-opacity: 0.71;
          "
        ></stop>
      </radialGradient>
    </defs>
  </svg>
</template>

<script setup>
const unicId = useId();
const unicIdPaint = useId();
</script>
